import type { Directive, DirectiveBinding } from 'vue'
import { useUserStore } from '@/stores/user'

type PermissionValue = string | string[]

const updatePermission = (el: HTMLElement, value?: PermissionValue) => {
  if (!value) {
    el.style.display = ''
    return
  }

  const userStore = useUserStore()
  const visible = userStore.hasPermission(value)
  el.style.display = visible ? '' : 'none'
}

const permission: Directive<HTMLElement, PermissionValue> = {
  mounted(el, binding: DirectiveBinding<PermissionValue>) {
    updatePermission(el, binding.value)
  },
  updated(el, binding: DirectiveBinding<PermissionValue>) {
    updatePermission(el, binding.value)
  },
}

export default permission
